import React from "react"
import styled from "styled-components"

const Map = () => (
  <MapDiv>
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9575.039717152256!2d-3.8799850560163622!3d53.13245497895454!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48651044ceddb2f3%3A0xdf9dd304884fc311!2sLlyn%20Crafnant%20Lakeside%20Cafe%20%26%20Fishing!5e0!3m2!1sen!2suk!4v1585835033040!5m2!1sen!2suk"
      height="320"
      width="100%"
      frameborder="0"
      style={{ border: 0, borderRadius: "10px" }}
      allowfullscreen=""
      aria-hidden="false"
      tabindex="0"
      title="google maps : Cafe"
    ></iframe>
  </MapDiv>
)

const MapDiv = styled.div`
  height: 320px;
  min-width: 220px;
  max-width: 600px;
  width: 80%;
  margin: 16px 0;
`
export default Map
